import React, { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import RootLayout from "./layouts/RootLayout";
import Upload from "./pages/upload/Upload";
import Security from "./pages/security/Security";
import Dangerous from "./pages/dangerous/Dangerous";
import Identify from "./pages/identify/Identify";
import Report from "./pages/report/Report";
import Dashboard from "./pages/dashboard/Dashboard";
import Pdf from "./pages/dangerous/Pdf";
import NewsDetail from "pages/security/NewsDetail";

import useApi from "hook/useApi";
import { login } from "api/auth";

const App = () => {
  const { execute } = useApi(login);

  useEffect(() => {
    execute();
  }, [execute]);

  return (
    <Routes>
      <Route element={<RootLayout />}>
        <Route index element={<Navigate to="/upload" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/upload" element={<Upload />} />
        <Route path="/security" element={<Security />} />
        <Route path="/security/news" element={<NewsDetail />} />
        <Route path="/dangerous" element={<Dangerous />} />
        <Route path="/dangerous/pdf" element={<Pdf />} />
        <Route path="/identify" element={<Identify />} />
        <Route path="/report" element={<Report />} />
      </Route>
    </Routes>
  );
};

export default App;
